import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

import FieldRendererBoolean from './FieldRendererBoolean';
import FormControlDate from './FormControlDate';
import FormControlString from './FormControlString';
import FormControlArea from './FormControlArea';
import FormControlNumber from './FormControlNumber';

const renderers = {
  "boolean": FieldRendererBoolean,
}

const controls = {
  "date": FormControlDate,
  "string": FormControlString,
  "area": FormControlArea,
  "number": FormControlNumber,
  "integer": FormControlNumber,
}

// Component to render the appropriate field based on schema property
const FieldRenderer = ({ name, property, field, isRequired }) => {
  if (!property.label) property.label = name.charAt(0).toUpperCase() + name.slice(1);
  const label = property.label;

  var Renderer = renderers[property.format || property.type];

  if (Renderer) {
    return (
      <Renderer
        name={name}
        property={property}
        field={field}
        isRequired={isRequired}
      />
    );
  }


  // For all other field types
  let CustomFormControl = controls[property.format || property.type];
  let formControl;

  if (CustomFormControl) {
    formControl = <CustomFormControl field={field} property={property} name={name} />
  } else {
    // Handle any other field types that don't have specific renderers just list string
    formControl = <FormControlString field={field} property={property} name={name} />
  }

  return (
    <FormItem>
      <FormLabel>
        {label}
        {isRequired && ' *'}
      </FormLabel>
      {formControl}
      {property.description && (
        <FormDescription>{property.description}</FormDescription>
      )}
      <FormMessage />
    </FormItem>
  );
};

export default FieldRenderer;